import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "@/lib/motion";

// Scroll-triggered reveal wrapper. Pass `variants` to override.
export const Reveal = ({ children, variants = fadeUp, custom = 0, className = "", as = "div", ...rest }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={variants}
      custom={custom}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
